import React from 'react';
import { motion } from 'framer-motion';
import './FoundersSection.css';

const FoundersSection = () => {
  const founders = [
    {
      name: "Sreyashi Desouza",
      title: "Founder, Saptapadi",
      message: `Marriage is one of life’s most sacred journeys, built on the foundations of trust, love, and shared dreams. At Saptapadi, I am devoted to helping you find that special person who completes your journey. With the highest standards of care, confidentiality, and ethics, we ensure that every introduction holds true value, making this chapter in your life as meaningful as it deserves to be.`,
      closing: "With warm regards,",
      avatar: "/images/f1.jpeg" // Dummy avatar for now
    },
    {
      name: "Ananya Borah",
      title: "Companionship Curator",
      message: `I am passionate about creating meaningful connections for those seeking not just a partner, but a true companion in life. To me, marriage is about shared vibes, deep understanding, and a bond that goes beyond the superficial. Through my work, I strive to ensure every introduction is intentional, heartfelt, and adds real value to one’s journey. Helping people find their perfect match is not just my profession, it’s my purpose.`,
      closing: "Sincerely,",
      avatar: "/images/f4.jpeg" // Dummy avatar for now
    },
    {
      name: "Deepali Waghmare Tayde ",
      title: "Manager – Emotional Connection & Client Growth",
      message: `I help individuals discover meaningful connections rooted in trust, understanding, and shared values. At Ssaptapadi, it’s more than just matchmaking — it’s about curating soulful new beginnings.`,
      closing: "Sincerely,",
      avatar: "/images/f3.jpeg" // Dummy avatar for now
    },
  ];

  return (
    <section className="founders-section">
      <h2>Our Founder’s Vision of Togetherness</h2>
      <div className="founders-container">
        {founders.map((founder, index) => (
          <motion.div
            key={index}
            className="founder-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut", delay: index * 0.3 }}
            viewport={{ once: true }}
          >
            <img src={founder.avatar} alt={`${founder.name}'s Avatar`} className="founder-avatar" />
            <div className="founder-content">
              <p className="founder-message">{founder.message}</p>
              <p className="founder-closing">{founder.closing}</p>
              <h3 className="founder-name">{founder.name}</h3>
              <p className="founder-title">{founder.title}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default FoundersSection;
